import InputWithFormatting from 'bcl/components/input/with-formatting';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
export default <template>
  <div
    class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2 col-span-6"
  >
    <label
      for={{@name}}
      class="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5 sm:text-right"
    >{{@label}}</label>
    <div class="mt-2 sm:col-span-2 sm:mt-0">
      <InputWithFormatting
        @type={{@type}}
        name={{@name}}
        id={{@name}}
        @value={{@value}}
        @update={{@update}}
        @updateMut={{@updateMut}}
        ...attributes
        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
      />
    </div>
  </div>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    label: string;
    name: string;
    value?: string;
    type?: string;
    update?: (value: unknown) => void; // function to call for update
    updateMut?: (value: string) => unknown; // function to reverse val => display
  };
  Element: HTMLInputElement;
}>;
